/* Lake Effect: tap a product photo to see it enlarged. */
(function () {
  'use strict';

  var dialog = null;
  var bigImg = null;

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'le-zoom';
    dialog.setAttribute('aria-label', 'Enlarged product photo');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'le-zoom__close';
    close.setAttribute('aria-label', 'Close enlarged photo');
    close.textContent = '×';

    bigImg = document.createElement('img');
    bigImg.className = 'le-zoom__img';
    bigImg.alt = '';

    dialog.appendChild(close);
    dialog.appendChild(bigImg);
    document.body.appendChild(dialog);

    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  function largestSrc(img) {
    var set = img.getAttribute('srcset');
    if (set) {
      var candidates = set.split(',').map(function (part) {
        return part.trim().split(/\s+/)[0];
      });
      return candidates[candidates.length - 1];
    }
    return img.currentSrc || img.src;
  }

  function open(img) {
    if (!dialog) buildDialog();
    bigImg.src = largestSrc(img);
    bigImg.alt = img.alt || '';
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  var imgs = document.querySelectorAll('[data-le-gallery-main] .le-media__img');
  Array.prototype.forEach.call(imgs, function (img) {
    img.classList.add('le-zoomable');
    img.addEventListener('click', function () { open(img); });
  });
})();
